import { Search } from "lucide-react";
import { useMemo, useState } from "react";
import { useAppSelector } from "../../../../app/store";
import InternalReportCard from "./InternalReportCard";
import ReportsPageLayout from "../common/ReportsPageLayout";
import PageTitle from "../../../pageheader/components/PageTitle";
import { getInternalReportsTypes } from "../../../configs/logic/Slice";
import { groupInternalReports } from "./internalReportConfig";

const InternalReportsLandingPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const reportTypes = useAppSelector(getInternalReportsTypes);

  const reportGroups = useMemo(
    () => groupInternalReports(reportTypes),
    [reportTypes]
  );

  const visibleGroups = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return reportGroups;
    return reportGroups
      .map((group) => ({
        ...group,
        reports: group.reports.filter((report) =>
          report.title.toLowerCase().includes(term)
        ),
      }))
      .filter((group) => group.reports.length > 0);
  }, [reportGroups, searchTerm]);

  const hasResults = visibleGroups.length > 0;

  return (
    <ReportsPageLayout>
      <PageTitle title="Reports" />

        <div className="relative mb-6 max-w-md">
          <Search
            size={16}
            strokeWidth={2}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]"
          />
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Search reports"
            className="h-9 w-full rounded-md border border-[#E5E5E5] bg-white pl-9 pr-3 text-sm text-[#171717] placeholder:text-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#263AAD]/20"
          />
        </div>

        {!hasResults ? (
          <p className="text-sm text-[#737373]">
            {reportGroups.length === 0
              ? "No reports have been enabled for your organization."
              : "No reports match your search."}
          </p>
        ) : (
          <div className="flex flex-col gap-6">
            {visibleGroups.map((group) => (
              <div key={group.group} className="flex flex-col gap-3">
                <p className="text-xs font-medium text-[#6B7280]">
                  {group.label}
                </p>
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
                  {group.reports.map((report) => (
                    <InternalReportCard key={report.id} report={report} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
    </ReportsPageLayout>
  );
};

export default InternalReportsLandingPage;
